export default {
  Mentions: 'Menciones',
  BrandHealth: 'Salud de la Marca',
};
